import { CANONICAL } from "./palettes.js";
import { UNIT_DRAWS, TOWER_DRAWS, ABSTRACT_DRAWS } from "./silhouettes.js";

export function renderIcon(key: string, size = 44): HTMLCanvasElement {
  const canvas = document.createElement("canvas");
  const dpr = window.devicePixelRatio || 1;
  canvas.width = size * dpr;
  canvas.height = size * dpr;
  canvas.style.width = `${size}px`;
  canvas.style.height = `${size}px`;

  const ctx = canvas.getContext("2d")!;
  ctx.scale(dpr, dpr);

  const draw = UNIT_DRAWS[key] ?? TOWER_DRAWS[key] ?? ABSTRACT_DRAWS[key];
  const palette = CANONICAL[key];
  if (draw !== undefined && palette !== undefined) {
    draw(ctx, size / 2, size / 2, size, palette);
  }
  return canvas;
}

export function hydrateIcons(root: ParentNode = document): void {
  const slots = root.querySelectorAll<HTMLElement>(".icon-slot[data-icon]");
  slots.forEach((slot) => {
    const key = slot.dataset.icon ?? "";
    if (key === "") return;
    // Self-healing: iconised stores the actual key last rendered, not a boolean.
    // If `data-icon` changes (reskin: fork pick or post-research substitution),
    // the mismatch triggers a re-render. Previously this was a "1" flag that got
    // stuck on the original icon, so reskins never updated visually.
    if (slot.dataset.iconised === key) return;
    slot.innerHTML = "";
    const sizeAttr = slot.dataset.iconSize;
    const size = sizeAttr !== undefined ? Number(sizeAttr) : 44;
    slot.appendChild(renderIcon(key, size));
    slot.dataset.iconised = key;
  });
}
